<script setup lang="ts">
const props = defineProps<{
  module: 'autopilot' | 'crm' | 'reviews' | 'loyalty' | 'looping'
}>()

const { t } = useI18n()
const { getStoreSchedulingPlatformUrl, selectedStore } = useStore()

const offer = ref('')
const link = ref('')

const routeParams = '?utm_source=pongo&utm_medium=dashboard&utm_campaign=upsell&utm_content='

const screenshotUrl = computed(() => {
  return `${import.meta.env.VITE_AWS_STORAGE_URL}/screenshots/${props.module}.png`
})

const populatePage = () => {
  switch (props.module) {
    case 'crm':
      break
    case 'loyalty':
      offer.value = `${t(`pages.settings.accountPage.payments.loyalty.title`)} ${t(
        `pages.settings.accountPage.payments.orModule`
      )} ${t(`pages.settings.accountPage.payments.reviews.title`)}`
      link.value = `${getStoreSchedulingPlatformUrl(selectedStore.value)}${routeParams}fidelite`
      break
    case 'autopilot':
      offer.value = `${t(`pages.settings.accountPage.payments.loyalty.title`)} ${t(
        `pages.settings.accountPage.payments.orModule`
      )} ${t(`pages.settings.accountPage.payments.reviews.title`)}`
      link.value = `${getStoreSchedulingPlatformUrl(selectedStore.value)}${routeParams}fidelite`
      break
    case 'reviews':
      offer.value = t(`pages.settings.accountPage.payments.reviews.title`)
      link.value = `${getStoreSchedulingPlatformUrl(selectedStore.value)}${routeParams}avis`
      break
    case 'looping':
      offer.value = t(`pages.settings.accountPage.payments.missed-calls.title`)
      link.value = `${getStoreSchedulingPlatformUrl(selectedStore.value)}${routeParams}appels`
      break
  }
}
populatePage()
</script>

<template>
  <div class="relative m-8 rounded-lg border bg-white pt-16 sm:pt-24">
    <div class="mx-auto max-w-md px-10 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
      <div>
        <h2 class="hidden text-xs font-semibold uppercase tracking-wider text-primary sm:inline sm:text-base">
          {{ t('accessDenied.noAccess') }}
        </h2>
        <p class="mt-2 text-xl font-extrabold tracking-tight text-foreground sm:text-3xl">
          {{ t('accessDenied.requires', { offer: offer }) }}
        </p>
        <p class="mx-auto mt-5 max-w-prose text-xs text-muted-foreground sm:text-xl">
          {{ t(`accessDenied.description.${module}`) }}
        </p>
        <a class="mt-6 inline-block" :href="link" target="_blank">
          <Button variant="default-primary">
            {{ t('accessDenied.button') }}
          </Button>
        </a>
      </div>
      <div class="-mb-10 mt-12 sm:-mb-24 lg:-mb-80">
        <img class="rounded-lg shadow-xl border" :src="screenshotUrl" :alt="module" />
      </div>
    </div>
  </div>
</template>
